import { ORGANIZATION_ALIAS } from '../constants';
import moment from 'moment';

export default (userData, uploadedBy) => {
  try {
    const isSubscribed =  
          userData.subscribed ||
          (userData.registrations && userData.registrations[0].organization.subscriptions[0].active) ||
          false;

    //const byName = `${userData.firstName} ${userData.lastName}`;

    // Already have a registration set, just return that.
    if(userData.registrations && userData.registrations.length) return userData.registrations;

    let registrations = [
        {
            "organization": {
                "_id": "",
                "name": ORGANIZATION_ALIAS,
                "registeredBy": uploadedBy,
                "memberTypes": [
                    "TBD (Default)"
                ],
                "group": userData.group || '',
                "referralUrl": "Admin Created User",
                "referredBy": "Admin",
            }
        }
    ];

    // "courseNameAlias": '',
    //     "startDate": moment().format('MM-DD-YYYY'),
    //     "endDate": moment().add(1, 'y').format('YYYY-MM-DD'),
    //     "isSubscribed": '',
    //     "processedBy": 'Manual',
    //     "subscribedBy": byName,
    //     active: true,
    //     isNew: true
    let newSubscriptions = [];
    if (userData['regenag-101']) {
      newSubscriptions.push({
        processedBy: "Manual",
        subscribedBy: uploadedBy,
        startDate: moment().valueOf(),
        endDate: moment().add(1, 'y').valueOf(),
        courseNameAlias: "regenag-101",
        isSubscribed: true,
        status: 'active'
      })
    }
    if (userData.cropping) {
      newSubscriptions.push({
        processedBy: "Manual",
        subscribedBy: uploadedBy,
        startDate: moment().valueOf(),
        endDate: moment().add(1, 'y').valueOf(),
        courseNameAlias: "cropping",
        isSubscribed: true,
        status: 'active'
      })
  }
  if (userData.grazing) {
    newSubscriptions.push({
      processedBy: "Manual",
      subscribedBy: uploadedBy,
      startDate: moment().valueOf(),
      endDate: moment().add(1, 'y').valueOf(),
      courseNameAlias: "grazing",
      isSubscribed: true,
      status: 'active'
    })
  }
  registrations[0].organization = {...registrations[0].organization, subscriptions: newSubscriptions}
  return registrations;
      
  } catch(e) {
    console.log(e.message);
    return []
  }
}

